module.exports = __webpack_public_path__ + "static/media/CRITICAL_21.78bfff51.svg";